import TasksView_Settings from "../settings"
import {BUS_SETTINGS_MANAGER_CONFIG_CHANGED} from "../../../../../gd/bus/bus-event-type"
import tasksView_Settings_isConfigChanged from "./is-config-changed"
import {AppSettingsMode} from "../../../../../manager/app-settings/app-settings"

// const debug = "tasksView_Settings_onChangeParameter"
const debug = false

export default function tasksView_Settings_onChangeParameter(settings: TasksView_Settings, paramName: string, value: any) {
    const _paramName            = '_{0}'.f(paramName)

    const previousValue         = _.cloneDeep(settings[_paramName as keyof {}])
    const newValue              = _.cloneDeep(value)

    // Determine if the parameter has actually changed (deep comparison)
    const isParameterChanged    = !_.isEqual(previousValue, newValue)

    debug && console.log(debug, "process", paramName, isParameterChanged, previousValue, newValue)

    if (isParameterChanged) {
        settings._mode = AppSettingsMode.CUSTOM

        // if the value changed, clear any inheritance and template, because
        // this is a direct manual change, not an application of a template
        settings._inheritedFromProject  = null
        settings._templateId            = undefined

        // set the property on the settings object
        // @ts-ignore
        settings[_paramName] = value

        // update the local settings to the latest config
        settings.localSettings.appSettings = settings.configToJSON()
        settings.localSettings.save()

        // if auto-saving is enabled and the config has changed,
        // update the stored config and call the auto-save handler
        if (!!settings.autoSaveFunction &&
            settings.autoSave &&
            tasksView_Settings_isConfigChanged(settings)) {
            settings._storedAppSettingsConfig = settings.configToJSON()
            settings.autoSaveFunction()  // save current view settings to project settings

            // because we save settings to project && this is default settings preset for this project
            // we should clean local settings (!)
            // we assume that save project settings always works (don't wait for success callback of the request)
            settings.reset()
        }

        gd.bus.triggerEvent(BUS_SETTINGS_MANAGER_CONFIG_CHANGED)
    }
}